$(document).ready(function() {
    $.blockUI(); 
});  

var IS_IPAD = navigator.userAgent.match(/iPad/i) != null ? true : false;

var CORDINATES = {
    'menscrewtee': {'front': {'x': 382, 'y': 182}, 'back': {'x': 383, 'y': 175}},
    'dtgcrewtee': {'front': {'x': 382, 'y': 182, t: 153, w: 190, h: 217}, 'back': {'x': 383, 'y': 175, t: 124, w: 190, h: 217}},
    'mensmoderntee': {'front': {'x': 382, 'y': 182}, 'back': {'x': 383, 'y': 175}},
    'menraglan': {'front': {'x': 384, 'y': 170}, 'back': {'x': 369, 'y': 155}},
    'menshoodies': {'front': {'x': 376, 'y': 300}, 'back': {'x': 373, 'y': 285}},
    'womencrewtee': {'front': {'x': 385, 'y': 195}, 'back': {'x': 387, 'y': 170}},
    'dtgwomencrewtee': {'front': {'x': 385, 'y': 195, t: 156, w: 189, h: 227}, 'back': {'x': 387, 'y': 170, t: 127, w: 189, h: 227}},
    'womentanktop': {'front': {'x': 380, 'y': 225}, 'back': {'x': 380, 'y': 250}},
    'youthcrewtee': {'front': {'x': 380, 'y': 170}, 'back': {'x': 378, 'y': 172}},
    'dtgkidscrewtee': {'front': {'x': 380, 'y': 170, t: 156, w: 192, h: 229}, 'back': {'x': 378, 'y': 172, t: 155, w: 192, h: 229}},
    'leggings': {'front': {'x': 357, 'y': 123}, 'back': {'x': 357, 'y': 123}},
    'towel': {'front': {'x': 371, 'y': 350}, 'back': {'x': 371, 'y': 350}},
    'blanket': {'front': {'x': 371, 'y': 350}, 'back': {'x': 371, 'y': 350}},
    'tapstry': {'front': {'x': 371, 'y': 350}, 'back': {'x': 371, 'y': 350}}
}

fabric.Image.prototype.strokeWidth = 0;

var imgFilters = [
    new fabric.Image.filters.Grayscale(), //0 grayscale
    new fabric.Image.filters.Contrast({
        contrast: 100
    }), //1 contrast
    new fabric.Image.filters.Sepia2(), //3 sepia2
];

//main canvas
var canvas = new fabric.Canvas('canvas', {
    preserveObjectStacking: true,
    controlsAboveOverlay: true,
    selectionCompatibility: true,
    stateful: true,
    selection: false,
    renderOnAddRemove: false, //true
    backgroundColor: 'white'
});

/**
 * Return an 
 * @param {DOMElement} el A dom element of a textarea or input text.
 * @return {Object} reference Object with 2 properties (start and end) with the identifier of the location of the cursor and selected text.
 **/
function getInputSelection(el) {
    var start = 0, end = 0, normalizedValue, range,
        textInputRange, len, endRange;

    if (typeof el.selectionStart == "number" && typeof el.selectionEnd == "number") {
        start = el.selectionStart;
        end = el.selectionEnd;
    } else {
        range = document.selection.createRange();

        if (range && range.parentElement() == el) {
            len = el.value.length;
            normalizedValue = el.value.replace(/\r\n/g, "\n");

            // Create a working TextRange that lives only in the input
            textInputRange = el.createTextRange();
            textInputRange.moveToBookmark(range.getBookmark());

            // Check if the start and end of the selection are at the very end
            // of the input, since moveStart/moveEnd doesn't return what we want
            // in those cases
            endRange = el.createTextRange();
            endRange.collapse(false);

            if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
                start = end = len;
            } else {
                start = -textInputRange.moveStart("character", -len);
                start += normalizedValue.slice(0, start).split("\n").length - 1;

                if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
                    end = len;
                } else {
                    end = -textInputRange.moveEnd("character", -len);
                    end += normalizedValue.slice(0, end).split("\n").length - 1;
                }
            }
        }
    }

    return {
        start: start,
        end: end
    };
}

if(IS_IPAD) {
    canvas.enableRetinaScaling = false;
} 

canvas.allowTouchScrolling = true;

//what happens when user selects an object
canvas.on({
    'canvas:cleared': function(e) {
        canvas.setBackgroundColor('white');
    },
    'object:added': function(e) {
        e.target.hasControls = e.target.hasBorders = false;
    },
    'object:moving': function(e) {
        e.target.opacity = 0.5;
    },
    'object:modified': onObjectModified,
    'object:selected': onObjectSelected
});

//on object selection
function onObjectSelected(e) {
    var selectedObject = e.target;
    selectedObject.hasRotatingPoint = true;
    if (selectedObject.get('id') === 'pattern' || selectedObject.get('id') === 'default-pattern') {
        $('.scale-pattern').val(parseFloat($('#'+current+'-pattern-scale').val()));
    }
    if (selectedObject.get('id') === 'i-text') {
        fabric.util.clearFabricFontCache(selectedObject.fontFamily);
        //clear font cache to avoid iText cursor placement issue
        $('#text-area').val(selectedObject.getText()).css('text-align', selectedObject.getTextAlign());
        //$('#font-size-slider').val(selectedObject.getFontSize()); 
        $("#" + selectedObject.getTextAlign()).addClass('active').siblings().removeClass('active');
        $("#" + selectedObject.getFontFamily()).addClass('active').siblings().removeClass('active');
        $("#" + rgbToHex(selectedObject.getFill())).addClass('active').siblings().removeClass('active');
    }
}

//on object selection clear
function onObjectModified(e) {
    e.target.opacity = 1;
    canvas.renderAll();
}

//stringify canvas
function stringifyCanvas() {
    //arrange objects
    canvas.forEachObject(function(obj) {
        if (obj.get('id') === 'pattern' || obj.get('id') === 'default-pattern') {
            obj.sendToBack();
        }
        if (obj.get('id') === 'i-text') {
            obj.bringToFront();
        }
        if (obj.get('id') === 'mask') {
            obj.selectable = false;
            obj.bringToFront();
        }
    });
    return JSON.stringify(canvas.toJSON(['objectCaching', 'id', 'selectable', 'crossOrigin', 'editable']));
}

//get active object
function getActiveObject() {
    return canvas.getActiveObject();
}

//remove object
function getObject(id) {
    var object = false;
    canvas.forEachObject(function(obj) {
        if (obj.get('id') === id) {
            object = obj;
            return false; //break
        } else {
            obj.selectable = false;
            canvas.sendBackwards(obj);
        }
    });
    return object;
}

//toggle object's visibility
function toggleVisibility(id) {
    canvas.forEachObject(function(obj) {
        if (obj.get('id') === id) {
            obj.toggle('visible'); //obj.visible = !obj.get('visible');
            obj.toggle('selectable'); //obj.visible = !obj.get('visible');
            return false;
        }
    });
}

//select object
function selectObject(id) {
    var obj = getObject(id);
    if ((id == 'pattern' && !obj) || (obj && obj.get('id') == 'pattern' && obj.get('visible') == false)) {
        obj = getObject('default-pattern');
    }
    if (obj) {
        obj.selectable = true;
        canvas.setActiveObject(obj).renderAll();
        canvas.getActiveObject().set('selectable', true);
        return true;
    }
    return false;
}

//remove object
function removeObject(id) {
    canvas.forEachObject(function(obj) {
        if (obj && obj.get('id') === id) {
            obj.remove();
            return false;
        }
    });
}

//rbg to hex
function rgbToHex(rgb) {
    return new fabric.Color(rgb).toHex();
}

//disable canvas
function disableCanvas() {
    canvas.selection = false;
    canvas.forEachObject(function(o) {
        o.hasBorders = o.hasControls = o.selectable = false;
    });
}

//set overlay image
function setOverlay(img) {
    fabric.Image.fromURL(img, function(overlayImg) {
        overlayImg.set({
            id: 'overlay',
            scaleY: canvas.height / overlayImg.height,
            scaleX: canvas.width / overlayImg.width,
            crossOrigin: 'anonymous'
        });
        try {  
            canvas.setOverlayImage(overlayImg, canvas.renderAll.bind(canvas));
        } catch (e) {
            bugsnagClient.notify(new Error(e));
            console.log(e);
        } 
    });
}

//apply pattern
function applyPattern(data, checkQuality = true, filterSelected = 5) {
    if (!$('.product_section').hasClass('pointer-cursor')) {
        $('.product_section').addClass('pointer-cursor');
    }
    removeObject('pattern');
    var dp_obj = getObject('default-pattern');
    if(dp_obj) {
        dp_obj.set('visible', false);
    }
    fabric.Image.fromURL(data, function(pattern) {
        pattern.id = 'pattern';
        //dtg
        if (mtCat.indexOf('dtg') !== -1) {        
            pattern.scaleToWidth(CORDINATES[mtCat][current].w);
            pattern.scaleToHeight(CORDINATES[mtCat][current].h);
            canvas.centerObject(pattern);
            pattern.setTop(CORDINATES[mtCat][current].t);
            canvas.add(pattern).setActiveObject(pattern).renderAll();
        } else {
            pattern.scaleToWidth(canvas.getWidth());
            pattern.scaleToHeight(canvas.getHeight());
            canvas.centerObject(pattern).add(pattern).setActiveObject(pattern).renderAll();
        }
        //check image quality
        if (checkQuality) {
            console.log('width: '+pattern.width);
            console.log('height: '+pattern.height);
            if (pattern.width >= 2000 && pattern.height >= 2000) {
                console.log('good');
                $('#pattern-quality-icon-' + current).attr('src', '//print-ready-store.myshopify.com/cdn/shop/t/4/assets/image%20quality%20good%20icon.png?v=13140069040624686401513578847').show();
                $('#pattern-quality-text-' + current).text('Uploaded image quality is good').show();
            } else {
                console.log('poor');
                $('#pattern-quality-icon-' + current).attr('src', 'https://print-ready-store.myshopify.com/cdn/shop/t/4/assets/sad-face.jpg?v=56058276034118959371513578959').show();
                $('#pattern-quality-text-' + current).text('Uploaded image quality is poor').show();
                //show warning
                $('#mtImgAgreement').css('display', 'block');
            }
            $('#drop-pattern').hide();
            $('.nav-toolbar.active').addClass('current').siblings().removeClass('current');
            $('.filters-' + current).show().find('img').attr('src', data);
        } else {
            m_obj = getObject('mask');
            pattern.filters[filterSelected] = imgFilters[filterSelected];
            pattern.applyFilters(function(e) {
                if (m_obj) {
                    canvas.bringToFront(m_obj);
                }
                canvas.sendToBack(pattern).renderAll();
            });
        }
    }, {
        crossOrigin: 'anonymous'
    });
    
    $('#image-toolbar').addClass('current');
    $('.patterns li, .filters li').removeClass('active').removeClass(current);
    $('.filters li:first-child').addClass('active').addClass(current);
    if(current == 'sleeve' && checkQuality) {
        showSleeveFilters();
    } else if(current == 'back' && checkQuality) {
        showBackFilters();
    } else { 
        showFrontFilters();
    }
    $('#'+current+'-pattern-scale').val(parseFloat(1));
    $('#scale-pattern-slider').show();
    $('#browse-pattern').val("");
    canvas.allowTouchScrolling = false;
}

//set text properties
function setTextProperties(text) {
    text.objectCaching = false;
    //for text
    text.set({
        fontFamily: (typeof $('.font-slider div.active').attr('id') == 'undefined' ? 'Bebas Neue' : $('.font-slider div.active').attr('id')),
        textAlign: $('#text-align li.active').attr('id'),
        fontSize: parseInt(32),
        fill: '#000000'
    });
}

//rotate object
$('.rotate').click(function(e) {
    var active = $('.nav-toolbar.active').attr('for');
    if (active == 'image-toolbar' || active == 'effects-toolbar') {
        selectObject('pattern');
    } else {
        selectObject('i-text');
    }

    var obj = getActiveObject();
    if (obj.get('id') == 'i-text') {
        var p_obj = getObject('pattern');
        var dp_obj = getObject('default-pattern');
        if (dp_obj) {
            canvas.sendToBack(dp_obj);
        } else {
            canvas.sendToBack(p_obj);
        }
    }
    if (obj) {
        obj.selectable = true;
        obj.setAngle(obj.getAngle() + 90);
        canvas.setActiveObject(obj).bringToFront(obj).renderAll();
    }
});

//center align object
$('.center').click(function(e) {
    var active = $('.nav-toolbar.active').attr('for');
    if (active == 'image-toolbar' || active == 'effects-toolbar') {
        selectObject('pattern');
    } else {
        selectObject('i-text');
    }

    var obj = getActiveObject();
    if (obj.get('id') == 'i-text') {
        var p_obj = getObject('pattern');
        var dp_obj = getObject('default-pattern');
        if (dp_obj) {
            canvas.sendToBack(dp_obj);
        } else {
            canvas.sendToBack(p_obj);
        }
    }
    if (obj) {
        obj.selectable = true;
        if(obj.get('id') == 'i-text') {
            if(mtCat == 'towel' || mtCat == 'blanket' || mtCat == 'tapstry') {
                obj.setTop(CORDINATES[mtCat][current].y  - parseFloat(obj.getBoundingRectHeight()/2));
            } else {
                obj.setTop(CORDINATES[mtCat][current].y);
            }
            obj.setLeft(CORDINATES[mtCat][current].x - parseFloat(obj.getBoundingRectWidth()/2));
            canvas.setActiveObject(obj).bringToFront(obj).renderAll();
        } else {
            canvas.setActiveObject(obj).centerObject(obj);
            //dtg
            if (mtCat.indexOf('dtg') !== -1) {
                obj.setTop(CORDINATES[mtCat][current].t + ((CORDINATES[mtCat][current].h - obj.getHeight())/2));
            }
            canvas.bringToFront(obj).renderAll();
        }
        obj.setCoords();
    }
});


//add text
$('#text-area').keyup(function(e) {
    var text = $(this).val();
    var p_obj = getObject('pattern');
    var dp_obj = getObject('default-pattern');
    var obj = getObject('i-text');
    if (!obj) {
        var obj = new fabric.IText(text, {
            id: 'i-text',
            editable: false,
            cursorWidth: 0,
        });
        setTextProperties(obj);
        canvas.centerObject(obj);
        obj.setTop(CORDINATES[mtCat][current].y);
        canvas.add(obj);
    } else {
        obj.setText(text);
    }
    if (dp_obj) {
        canvas.sendToBack(dp_obj);
    } else {
        canvas.sendToBack(p_obj);
    }
    obj.selectable = true;
    canvas.setActiveObject(obj).renderAll();
});

//change text font size properties
$('#font-size-slider').change(function(e) {
    var input = document.getElementById("text-area");
    var result = getInputSelection(input);
    
    var p_obj = getObject('pattern');
    var dp_obj = getObject('default-pattern');
    var obj = getObject('i-text');
    if (!obj) {
        return;
    }
    if (dp_obj) {
        canvas.sendToBack(dp_obj);
    } else {
        canvas.sendToBack(p_obj);
    }

    if(result.start == result.end){          
        obj.set('fontSize', parseInt($(this).val()));
    }else{
        obj.editable = true;
        obj.enterEditing();
        obj.selectionStart = result.start;
        obj.selectionEnd = result.end;
        if (obj.setSelectionStyles && obj.isEditing) {
            var style = {};
            style['fontSize'] = parseInt($(this).val());
            obj.setSelectionStyles(style);
        }
        obj.exitEditing();
        obj.editable = false;
    }
    obj.selectable = true;
    obj.setCoords();
    canvas.setActiveObject(obj).renderAll();
});

//change text alignment
$('#text-align li').click(function(e) {
    var p_obj = getObject('pattern');
    var dp_obj = getObject('default-pattern');
    var obj = getObject('i-text');
    var align = $(this).attr('id');
    if (!obj)
        return;
    $(this).addClass('active').siblings().removeClass('active');
    $('#text-area').css('text-align', align);
    if (dp_obj) {
        canvas.sendToBack(dp_obj);
    } else {
        canvas.sendToBack(p_obj);
    }
    obj.set('textAlign', $(this).attr('id'));
    if (align == 'left') {
        obj.setLeft(parseFloat(CORDINATES[mtCat][current].x - obj.getBoundingRectWidth()));
    } else if (align == 'right') {
        obj.setLeft(CORDINATES[mtCat][current].x);
    } else {
        obj.setLeft(CORDINATES[mtCat][current].x - parseFloat(obj.getBoundingRectWidth()/2));
    }
    obj.selectable = true;
    canvas.setActiveObject(obj).renderAll();
    obj.setCoords();
});

//change text fill
$('.product-custom .font-color li, .product-personalized .font-color li').click(function(e) {
    if ($(this).hasClass('color-picker')) {
        $(this).siblings().removeClass('active');
        return true;
    } else {
        var p_obj = getObject('pattern');
        var dp_obj = getObject('default-pattern');
        var obj = getObject('i-text');
        if (!obj)
            return;
        $(this).addClass('active').siblings().removeClass('active');
        obj.set('fill', "#" + $(this).attr('id'));
        obj.selectable = true;
        canvas.setActiveObject(obj).renderAll();
    }
});

//more color picker
$('.product-custom .font-color li img, .product-personalized .font-color li img').click(function(e) {
    $(this).parents('li').trigger('click');
});

$('.product-custom .color-picker a, .product-personalized .color-picker a').spectrum({
    color: "#0027ff",
    clickoutFiresChange: false,
    showButtons: false,
    move: function(color) {
        $(".product-custom .custom-color, .product-personalized .custom-color").attr('id', color.toHexString().replace('#', '')).trigger('click');
    }
});

$('.product-custom .color-picker a, .product-personalized .color-picker a').on("dragstop.spectrum", function(e, color) {
    $('.product-personalized .color-picker a').spectrum("hide");
});

//convert to blob
function b64toBlob(b64Data, contentType, sliceSize) {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;

  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }
    
    //var blob = new Blob(byteArrays, {type: contentType});
    try{
        var blob = new Blob( byteArrays, {type : contentType});
    } catch(e){
        // TypeError old chrome and FF
        window.BlobBuilder = window.BlobBuilder || 
                                window.WebKitBlobBuilder || 
                                window.MozBlobBuilder || 
                                window.MSBlobBuilder;
        if(e.name == 'TypeError' && window.BlobBuilder){
            var bb = new BlobBuilder();
            bb.append(byteArrays);
            var blob = bb.getBlob(contentType);
        }
        else if(e.name == "InvalidStateError"){
            // InvalidStateError (tested on FF13 WinXP)
            var blob = new Blob(byteArrays, {type : contentType});
        }
        else{
	    bugsnagClient.notify('Unsuppoerted browser');
            alert("Your browser doesn't supports some functionalities.");  
        }
    }
    
    return blob;
}

//capture canvas
function captureCanvas(current) {
    //get image for preview for back
    try {        
        var img = canvas.toDataURL({
            format: 'png'
        });
    } catch (e) {
        bugsnagClient.notify(new Error(e));
        console.log(e);
    }   
    
    //window.open(img);
    if(current === 'back') {
        $('.flex-control-nav li:last-child').find('img').attr('src', img);
    } else {
        $('.flex-control-nav li:first-child').find('img').attr('src', img); 
    }
    var blob = img.replace(/^data:image\/(png|jpeg);base64,/, "");
    $('#final_' + current + '_img').val(blob);
    return true;
}

//get preview
function getPreview(current, step) {
    if(current == 'order') { return false; }
    
    if(current == 'sleeve') { current = 'front'; }

    //capture back preview if checked repeat or added sleeve
    if(typeof back !== 'undefined' && Object.keys(back).length > 0 && step !== 'back') {      
        var tmp = stringifyCanvas();
        canvas.clear();
        canvas.loadFromJSON(JSON.parse(back), function() {
            canvas.renderAll().calcOffset();
            if(captureCanvas('back')) {
                canvas.loadFromJSON(JSON.parse(tmp), function() {
                    $.each(canvas.getObjects(), function(pos, obj) {
                        if(obj && (obj.get('id') == 'pattern' || obj.get('id') == 'default-pattern')) {
                            canvas.sendToBack(obj);
                        } else {
                            canvas.bringToFront(obj);
                        }
                    });
                    canvas.renderAll().calcOffset();
                    captureCanvas(current);
                });
            }
        });
    } else {
        captureCanvas(current);
    }
}